import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const scatterPlotTool: Tool = {
  id: "scatter-plot",
  name: () => m.scatter_tool_name(),
  description: () => m.scatter_tool_description(),
  icon: "⚬",
  basePath: "/scatter-plot",
  status: "stable",
  tags: ["chart", "plot", "data-visualization", "scatter-plot", "science"],
};
